import React, {useEffect, useState} from 'react';
import '../Body.css';
import './Ergebnisse.css';
import NavbarDisziplin from "./NavbarDisziplin";
import NavbarLiga from "./NavbarLiga";
import ConfigDurchgang from "./ConfigDurchgang";
import NeuesErgebnis from "./NeuesErgebnis";
import ApiService from "../services/ApiService";

function Ergebnisse(token) {
    const [loading, setLoading] = useState(false);

    const [disziplinList, setDisziplinList] = useState([]);
    const [ligaList, setLigaList] = useState([]);
    const [daten, setDaten] = useState(null);
    const [selectedWettkampfId, setSelectedWettkampfId] = useState(null);
    const [selectedLiga, setSelectedLiga] = useState(null);
    const [selectedDisziplin, setSelectedDisziplin] = useState(null);

    const [disziplinInfos, setDisziplinInfos] = useState({});
    const [mannschaftInfos, setMannschaftInfos] = useState({});
    const [matchingPersons, setMatchingPersons] = useState(null);

    const handleDisziplinClick = (selectedCode) => {
        const disziplin = disziplinList.find(dis => dis.code === selectedCode)
        setSelectedDisziplin(disziplin);
        setDisziplinInfos({
            requiredStarters: disziplin.requiredStarters,
            requiredSeries: disziplin.requiredSeries
        });
        setSelectedLiga(null);
        setMatchingPersons(null);
        setDaten(null);
        ApiService.fetchLigenByDisziplin(selectedCode)
            .then(data => {
                setLigaList(data);
                setLoading(false);
            })
            .catch(error => console.error('Fehler beim Laden der Ligen:', error));
    };

    const handleLigaClick = (selectedLiga) => {
        setSelectedLiga(selectedLiga);
        setMatchingPersons(null);
        setDaten(null);
        //    setLoading(true);
         try {
            ApiService.fetchPaarungen(2026, selectedLiga.id)
                .then(data => {
                    setDaten(data);
                });
        } catch (error) {
            console.error('Fehler beim Laden der Daten für die rechte Spalte:', error);
        }
    };

    const handleMannschaftClick = (wettkampfId, selectedMannschaftId, selectedMannschaftName) => {
        setMannschaftInfos({id: selectedMannschaftId, name: selectedMannschaftName});
        setSelectedWettkampfId(wettkampfId);
        setMatchingPersons(null);

       ApiService.fetchPersonsByMannschaft(token, selectedMannschaftId)
            .then(data => {
                setMatchingPersons(data);
                setLoading(false);
            })
            .catch(error => console.error('Fehler beim Laden der Ligen:', error));
    }

    useEffect(() => {
        setLoading(true);
        ApiService.fetchDisziplin()
                .then(data => {
                    setDisziplinList(data);
                    setLoading(false);
                })
                .catch(error => console.error('Fehler beim Laden der Disziplinen:', error));
    }, []);

    if (loading) {
        return <p>Loading...</p>;
    }

    return (
        <div className="element-content element-background">
            <div className="grid-container-ergebnisse">
                <div className="top-panel-liste">
                    <NavbarDisziplin disziplinList={disziplinList} handleDisziplinClick={handleDisziplinClick} selectedDisziplin={selectedDisziplin}/>
                    <NavbarLiga ligaList={ligaList} handleLigaClick={handleLigaClick} selectedLiga={selectedLiga}></NavbarLiga>
                </div>
                <div className="left-panel-ergebnisse">
                    {daten && (
                        <div>
                            <ConfigDurchgang wettkampfData={daten}
                                             handleMannschaftClick={handleMannschaftClick}></ConfigDurchgang>
                        </div>
                    )}
                </div>
                {matchingPersons && (
                    <div className="right-panel-ergebnisse">
                        <NeuesErgebnis token={token}
                                       wettkampfId={selectedWettkampfId}
                                       disziplin={disziplinInfos}
                                       mannschaft={mannschaftInfos}
                                       matchingPersons={matchingPersons}></NeuesErgebnis>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Ergebnisse;
